export default __webpack_public_path__ + "static/media/popuphookslide.b96e420f.png";